// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__18--8","col":"styles_col__b9eDs"};